import { LoadingPage } from '../ui/loading-page';

interface LoadingStateProps {
  type?: 'dashboard' | 'table' | 'form' | 'cards';
  title?: string;
  message?: string;
}

export function LoadingState({ 
  type = 'dashboard', 
  title,
}: LoadingStateProps) {
  return (
    <div className="space-y-6">
      {title && (
        <div className="space-y-2">
          <div className="shimmer h-8 w-48 rounded" />
          <div className="shimmer h-4 w-96 rounded" />
        </div>
      )}
      <LoadingPage type={type} title={title} />
    </div>
  );
}
